import { useQuery } from '@tanstack/react-query';
import { systemHealthApi } from '../api/client';
import type { SystemHealthDashboard } from '../api/client';

const QUERY_KEY = 'system-health-dashboard';

export function useSystemHealth() {
  return useQuery<SystemHealthDashboard, Error>({
    queryKey: [QUERY_KEY],
    queryFn: () => systemHealthApi.getDashboard(),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
